import { AnyAction, Reducer } from 'redux'

import {
  FETCHING_PAYMENT_STATUS,
  PAYMENT_FAILED,
  PAYMENT_STATUS_FETCHED,
  PAYMENT_SUCCESS,
  PAYMENT_URL_INVALID,
} from './Actions'
import { IPreviousAppointment, TMolliePaymentStatus } from '../../PreviousAppointments/IPreviousAppointment'


export type TPaymentFallback = {
  fetching: boolean
  status: TMolliePaymentStatus | 'invalidUrl'
  paidAppointment?: IPreviousAppointment
}

const initialState: TPaymentFallback = {
  fetching: false,
  status: 'open',
}

export const reducer: Reducer<TPaymentFallback> = (
  // eslint-disable-next-line default-param-last
  state = initialState,
  action: AnyAction): TPaymentFallback => {
  switch (action.type) {
    case PAYMENT_URL_INVALID:
      return {
        ...state,
        fetching: false,
        status: 'invalidUrl',
      }
    case FETCHING_PAYMENT_STATUS:
      return {
        ...state,
        fetching: true,
      }
    case PAYMENT_FAILED:
      return {
        ...state,
        fetching: false,
        status: 'failed',
      }
    case PAYMENT_SUCCESS:
      return {
        ...state,
        fetching: false,
        status: 'paid',
        paidAppointment: action.appointment,
      }
    case PAYMENT_STATUS_FETCHED:
      return {
        ...state,
        fetching: false,
      }
    default:
      return state
  }
}
